import { render, staticRenderFns } from "./QfpayWidget.vue?vue&type=template&id=2895c829&"
import script from "./QfpayWidget.vue?vue&type=script&lang=js&"
export * from "./QfpayWidget.vue?vue&type=script&lang=js&"
import style0 from "./QfpayWidget.vue?vue&type=style&index=0&id=2895c829&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports